import { api } from '@/lib/api';
import type { NetworkTopologyResponse, RouteRecordsResponse } from './types';

export async function getNetworkTopology(siteId: string): Promise<NetworkTopologyResponse> {
  return api.get<NetworkTopologyResponse>(`/v4/network-topology/${siteId}`);
}

export async function getRouteRecords(siteId: string): Promise<RouteRecordsResponse> {
  return api.get<RouteRecordsResponse>(`/v4/network-topology/${siteId}/routes`);
}
